import App from './App'
import React from 'react'
import ReactDOM from 'react-dom'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import './tailwind.css'

dayjs.extend(relativeTime)

// should we disable strict mode? 🤔
// https://github.com/reactwg/react-18/discussions/19
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)
